import axios from 'axios';

const apiUrl = process.env.REACT_APP_ALCATRAZ_FLIGHT_SERVICE;

const postApi = {
  /**
   * Get posts method
   * @param params
   * @returns {Promise<>}
   */
  getPost: (params = {}, token) => axios.get(`${apiUrl}/api/v1/post/`, {
    params,
    headers: {
      'x-access-token': token,
    },
  }),

  /**
   * Patch Posts method
   * @param postId
   * @param data
   * @returns {Promise<>}
   */
  patchPost: (postId, data, token) => axios.patch(`${apiUrl}/api/v1/post/${postId}`, data, {
    headers: {
      'x-access-token': token,
    },
  }),

  /**
   * actionPost method, updates a post status according to action
   * @param postId
   * @param data
   * @returns {Promise<>}
   */
  actionPost: (postId, data, token) => axios.post(`${apiUrl}/api/v1/post/action/${postId}`, data, {
    headers: {
      'x-access-token': token,
    },
  }),
};

export default postApi;
